/**
 * Issue (policy topic) configuration for the Internal / tooltip views.
 * Keyed by database field name (e.g. "inflation_issue_n").
 */
export const ISSUE_INFO = {
  inflation_issue_n:      { name: "Inflation",      color: "#D98A36" },
  health_issue_n:         { name: "Health",          color: "#C23B72" },
  econ_issue_n:           { name: "Economy",         color: "#2A9FD6" },
  crime_issue_n:          { name: "Crime",           color: "#8253C8" },
  housing_issue_n:        { name: "Housing",         color: "#CC7046" },
  poverty_issue_n:        { name: "Poverty",         color: "#CC3333" },
  unemployment_issue_n:   { name: "Unemployment",    color: "#CCB830" },
  climate_issue_n:        { name: "Climate",         color: "#2BA84A" },
  education_issue_issue_n:{ name: "Education",       color: "#2B78E4" },
  transport_issue_n:      { name: "Transport",       color: "#D1691F" },
  drugs_issue_n:          { name: "Drugs",           color: "#A6A832" },
  race_rel_issue_n:       { name: "Race relations",  color: "#1EB7B7" },
  tax_issue_n:            { name: "Tax",             color: "#B94D4D" },
  pollution_issue_n:      { name: "Pollution",       color: "#707070" },
  maori_issue_n:          { name: "Māori",           color: "#9C3E1D" },
  immigration_issue_n:    { name: "Immigration",     color: "#C4A22E" },
  defence_issue_n:        { name: "Defence",         color: "#335CBA" },
};
